// 葡萄牙语
export const GUIDES = [
  { name: 'guide-overview', title: 'Visão geral das funções', groupIndex: 0 },
  { name: 'guide-account', title: 'Sobre Account', groupIndex: 0 },
  { name: 'guide-vehicle', title: 'Sobre o veículo', groupIndex: 0 },
  { name: 'guide-meterSetting', title: 'Como configurar o painel de instrumentos', groupIndex: 1 },
  { name: 'guide-vehicleSetting', title: 'Como configurar o veículo', groupIndex: 1 },
  { name: 'guide-findNavigation', title: 'Como navegar para encontrar o veículo', groupIndex: 2 },
  { name: 'guide-vehicleNnavigation', title: 'Como utilizar a navegação', groupIndex: 2 },
  { name: 'guide-cyclingRecord', title: 'Sobre a História do Ride', groupIndex: 3 },
  { name: 'guide-vehicleExperience', title: 'Como realizar uma auto-inspecção de um veículo', groupIndex: 3 },
  { name: 'guide-useSetting', title: 'Como fazer as configurações gerais do APP', groupIndex: 3 },
  { name: 'guide-notice', title: 'Como visualizar e definir a notificação de mensagem', groupIndex: 3 },
  { name: 'guide-about', title: 'Sobre o APP', groupIndex: 4 },
];

// 息屏引导列表
export const REST_SCREENS = [
  { icon: 'vivo', name: 'vivo', title: 'VIVO' },
  { icon: 'mi', name: 'mi', title: 'MI' },
  { icon: 'huawei', name: 'huawei', title: 'HUAWEI' },
  { icon: 'honor', name: 'honor', title: 'HONOR' },
];

export const FEEDBACK_STATES = {
  0: 'Pendente',
  1: 'Sem resposta',
  2: 'Respondido',
  3: 'em comunicação',
  4: 'contramedidas',
  5: 'resolvido',
};

export const FEEDBACK_TYPES = {
  1: 'Feedback',
  2: 'Resposta',
};

export default {
  GUIDES,
  REST_SCREENS,
  FEEDBACK_STATES,
  FEEDBACK_TYPES,
};
